<template>
  <div
      v-if="bannerText"
      :class="containerClasses"
      :style="bannerStyles"
      style="z-index: 100"
  >
    <p class="text-sm" :style="textStyles">
      {{ bannerText }}
      <a
          :href="cookiePolicyLink"
          class="underline text-blue-300"
      >Learn more</a>
    </p>
    <button
        class="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
        @click="closeBanner"
    >
      Close
    </button>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'CookieBanner',
  props: ['widgetId'],
  data() {
    return {
      bannerText: '',
      cookiePolicyLink: '',
      backgroundColour: '',
      textColour: '',
      bannerType: '' // Default type
    };
  },
  computed: {
    bannerStyles() {
      // Base styles for the container
      const styles = {
        backgroundColor: this.backgroundColour || '#1a202c', // Fallback to bg-gray-900 (#1a202c)
      };

      // Add specific styles for card types
      if (this.bannerType.startsWith('card')) {
        styles.position = 'fixed';
        styles.width = '300px';
        styles.padding = '1rem';
        styles.borderRadius = '0.5rem';
        styles.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)';
        styles.display = 'flex';
        styles.flexDirection = 'column';
        styles.gap = '0.75rem';
        styles.alignItems = 'flex-start';
      }
      return styles;
    },
    textStyles() {
      return {
        color: this.textColour || '#ffffff',
      };
    },
    containerClasses() {
      const classes = [];

      if (this.bannerType.includes('banner')) {
        classes.push('fixed', 'inset-x-0', 'p-4', 'flex', 'justify-between', 'items-center');
      }

      switch (this.bannerType) {
        case 'banner_bottom':
          classes.push('bottom-0');
          break;
        case 'banner_top':
          classes.push('top-0');
          break;
        case 'card_left':
          classes.push('bottom-4', 'left-4');
          break;
        case 'card_right':
          classes.push('bottom-4', 'right-4');
          break;
        default:
          // Fallback to default banner bottom if type is unknown
          classes.push('fixed', 'inset-x-0', 'bottom-0', 'p-4', 'flex', 'justify-between', 'items-center');
          break;
      }
      return classes;
    }
  },
  mounted() {
    this.fetchBannerData();
  },
  methods: {
    async fetchBannerData() {
      try {
        let rawApiResponse = await axios.get(process.env.VUE_APP_API_URL + '/api/widget/' + this.widgetId);
        let apiResponse = rawApiResponse.data;
        this.bannerText = apiResponse.bannerText;
        this.cookiePolicyLink = apiResponse.cookiePolicyLink;
        this.backgroundColour = apiResponse.backgroundColour;
        this.textColour = apiResponse.textColor;

        if (apiResponse.bannerType) {
          this.bannerType = apiResponse.bannerType.toLowerCase();
        }
      } catch (error) {
        console.error("Error fetching banner data:", error);
      }
    },
    closeBanner() {
      this.bannerText = '';
    }
  }
};
</script>

<style scoped>
/* Add any custom styles here */
</style>